import { apiJsonApiCall } from '@routable/framework';
import { annotationResponseModel } from './annotation.models';
export const annotationService = {
    get: ({ annotationId }) => apiJsonApiCall({
        method: 'get',
        responseModel: annotationResponseModel,
        url: `ocr/annotations/${annotationId}/`,
    }),
    cancelReview: ({ annotationId }) => apiJsonApiCall({
        method: 'post',
        responseModel: annotationResponseModel,
        url: `ocr/annotations/${annotationId}/cancel_review/`,
    }),
};
